import biryaniImg from "../assets/images/biryani.jpg";
import chick_fryImg from "../assets/images/chick_fry.jpg";
import choleImg from "../assets/images/chole.jpg";
import croqueImg from "../assets/images/croque.jpg";
import dosaImg from "../assets/images/dosa.jpg";
import lemonImg from "../assets/images/lemon.jpg";
import paneerImg from "../assets/images/paneer.jpg";
import pastaImg from "../assets/images/pasta.png";
import pizzaImg from "../assets/images/pizza.jpg";
import ratImg from "../assets/images/rat.jpg";
import risotaImg from "../assets/images/risota.jpeg";
import tom_omImg from "../assets/images/tom_om.jpg";
import mangoImg from "../assets/images/mango.jpg";
import butterImg from "../assets/images/butter.jpg";
import pancakeImg from "../assets/images/pancake.jpg";

export const pantryItems = [
  { id: 1, name: "Eggs", quantity: 6, unit: "pcs", category: "Dairy & Eggs", emoji: "🥚" },
  { id: 2, name: "Whole Milk", quantity: 1, unit: "L", category: "Dairy & Eggs", emoji: "🥛" },
  { id: 3, name: "Butter", quantity: 200, unit: "g", category: "Dairy & Eggs", emoji: "🧈" },
  { id: 4, name: "Tomatoes", quantity: 4, unit: "pcs", category: "Vegetables", emoji: "🍅" },
  { id: 5, name: "Garlic", quantity: 1, unit: "bulb", category: "Vegetables", emoji: "🧄" },
  { id: 6, name: "Onion", quantity: 3, unit: "pcs", category: "Vegetables", emoji: "🧅" },
  { id: 7, name: "Spaghetti", quantity: 500, unit: "g", category: "Grains", emoji: "🍝" },
  { id: 8, name: "Basmati Rice", quantity: 2, unit: "kg", category: "Grains", emoji: "🍚" },
  { id: 9, name: "Chicken Breast", quantity: 500, unit: "g", category: "Meat", emoji: "🍗" },
  { id: 10, name: "Olive Oil", quantity: 500, unit: "ml", category: "Pantry", emoji: "🫒" },
  { id: 11, name: "Salt", quantity: 300, unit: "g", category: "Pantry", emoji: "🧂" },
  { id: 12, name: "Lemon", quantity: 2, unit: "pcs", category: "Fruits", emoji: "🍋" },
];

export const recipes = [
  {
    id: 1,
    name: "Spaghetti Aglio e Olio",
    cuisine: "Italian",
    time: "20 min",
    difficulty: "Easy",
    emoji: "🍝",
    image: pastaImg,
    description: "A classic Roman pasta dish with garlic, olive oil, and parsley.",
    ingredients: [
      { name: "Spaghetti", quantity: "200g" },
      { name: "Garlic", quantity: "4 cloves" },
      { name: "Olive Oil", quantity: "4 tbsp" },
      { name: "Red Chili Flakes", quantity: "1 tsp" },
      { name: "Parsley", quantity: "a handful" },
      { name: "Salt", quantity: "to taste" },
    ],
    steps: [
      "Boil spaghetti in salted water until al dente.",
      "Slice garlic thinly and sauté in olive oil over low heat until golden.",
      "Add red chili flakes, then toss in the cooked pasta.",
      "Add pasta water as needed for a silky sauce.",
      "Finish with fresh parsley and serve immediately.",
    ],
  },
  {
    id: 2,
    name: "Chicken Stir Fry",
    cuisine: "Asian",
    time: "25 min",
    difficulty: "Medium",
    emoji: "🍳",
    image: chick_fryImg,
    description: "Quick and flavourful stir fry with vegetables and tender chicken.",
    ingredients: [
      { name: "Chicken Breast", quantity: "300g" },
      { name: "Soy Sauce", quantity: "3 tbsp" },
      { name: "Garlic", quantity: "3 cloves" },
      { name: "Ginger", quantity: "1 inch" },
      { name: "Bell Peppers", quantity: "2 pcs" },
      { name: "Sesame Oil", quantity: "1 tbsp" },
    ],
    steps: [
      "Slice chicken breast thin and marinate in soy sauce for 10 mins.",
      "Heat oil in a wok over high heat.",
      "Add garlic and ginger, stir for 30 seconds.",
      "Add chicken and cook until golden.",
      "Toss in bell peppers and stir fry for 3-4 minutes.",
      "Drizzle sesame oil and serve over rice.",
    ],
  },
  {
    id: 3,
    name: "Tomato Basil Omelette",
    cuisine: "French",
    time: "10 min",
    difficulty: "Easy",
    emoji: "🍳",
    image: tom_omImg,
    description: "Fluffy morning omelette with garden tomatoes and fresh basil.",
    ingredients: [
      { name: "Eggs", quantity: "3 pcs" },
      { name: "Tomatoes", quantity: "1 pc" },
      { name: "Butter", quantity: "1 tbsp" },
      { name: "Fresh Basil", quantity: "5 leaves" },
      { name: "Salt", quantity: "to taste" },
    ],
    steps: [
      "Whisk eggs with a pinch of salt until light.",
      "Melt butter in a non-stick pan over medium heat.",
      "Pour in eggs and let them set on the bottom.",
      "Add diced tomatoes and basil.",
      "Fold omelette in half and serve.",
    ],
  },
  {
    id: 4,
    name: "Lemon Garlic Rice",
    cuisine: "Mediterranean",
    time: "30 min",
    difficulty: "Easy",
    emoji: "🍋",
    image: lemonImg,
    description: "Fluffy basmati rice infused with lemon zest and roasted garlic.",
    ingredients: [
      { name: "Basmati Rice", quantity: "1 cup" },
      { name: "Garlic", quantity: "4 cloves" },
      { name: "Lemon", quantity: "1 pc" },
      { name: "Olive Oil", quantity: "2 tbsp" },
      { name: "Salt", quantity: "to taste" },
    ],
    steps: [
      "Rinse basmati rice and soak for 20 minutes.",
      "Sauté minced garlic in olive oil until fragrant.",
      "Add rice and stir to coat in oil.",
      "Add water, lemon zest, and salt. Cook covered for 18 minutes.",
      "Fluff with fork and finish with lemon juice.",
    ],
  },
  {
  id: 5,
  name: "Paneer Butter Masala",
  cuisine: "Asian",
  time: "30 min",
  difficulty: "Medium",
  emoji: "🍛",
  image: paneerImg,
  description: "Rich and creamy tomato-based curry with soft paneer cubes.",
  ingredients: [
    { name: "Paneer", quantity: "200g" },
    { name: "Tomato Puree", quantity: "1 cup" },
    { name: "Butter", quantity: "2 tbsp" },
    { name: "Cream", quantity: "3 tbsp" },
    { name: "Garam Masala", quantity: "1 tsp" },
  ],
  steps: [
    "Heat butter and sauté spices.",
    "Add tomato puree and cook until thick.",
    "Add paneer cubes and simmer.",
    "Stir in cream and cook for 2 minutes.",
    "Serve hot with naan or rice."
  ],
},
{
  id: 6,
  name: "Masala Dosa",
  cuisine: "Asian",
  time: "40 min",
  difficulty: "Medium",
  emoji: "🥞",
  image: dosaImg,
  description: "Crispy dosa filled with spiced potato masala.",
  ingredients: [
    { name: "Dosa Batter", quantity: "2 cups" },
    { name: "Potatoes", quantity: "3 pcs" },
    { name: "Onion", quantity: "1 pc" },
    { name: "Mustard Seeds", quantity: "1 tsp" },
    { name: "Curry Leaves", quantity: "few" },
  ],
  steps: [
    "Prepare potato masala by sautéing onions and spices.",
    "Spread dosa batter on hot pan.",
    "Cook until crispy.",
    "Add potato filling and fold.",
    "Serve with chutney and sambar."
  ],
},
{
  id: 7,
  name: "Chole Bhature",
  cuisine: "Asian",
  time: "45 min",
  difficulty: "Medium",
  emoji: "🥘",
  image: choleImg,
  description: "Spicy chickpea curry served with fluffy fried bread.",
  ingredients: [
    { name: "Chickpeas", quantity: "1 cup" },
    { name: "Onion", quantity: "1 pc" },
    { name: "Tomato", quantity: "2 pcs" },
    { name: "Chole Masala", quantity: "2 tsp" },
    { name: "Flour", quantity: "2 cups" },
  ],
  steps: [
    "Cook chickpeas until soft.",
    "Prepare spicy gravy with onion and tomato.",
    "Add chickpeas and simmer.",
    "Prepare dough and fry bhature.",
    "Serve hot together."
  ],
},
{
  id: 8,
  name: "Vegetable Biryani",
  cuisine: "Asian",
  time: "50 min",
  difficulty: "Hard",
  emoji: "🍚",
  image: biryaniImg,
  description: "Aromatic rice dish cooked with mixed vegetables and spices.",
  ingredients: [
    { name: "Basmati Rice", quantity: "1 cup" },
    { name: "Mixed Vegetables", quantity: "1 cup" },
    { name: "Yogurt", quantity: "1/2 cup" },
    { name: "Biryani Masala", quantity: "2 tsp" },
    { name: "Saffron", quantity: "a pinch" },
  ],
  steps: [
    "Cook rice partially.",
    "Prepare vegetable masala.",
    "Layer rice and vegetables.",
    "Cook on low heat (dum).",
    "Serve hot with raita."
  ],
},
{
  id: 9,
  name: "Margherita Pizza",
  cuisine: "Italian",
  time: "30 min",
  difficulty: "Medium",
  emoji: "🍕",
  image: pizzaImg,
  description: "Classic Italian pizza with fresh tomato, mozzarella, and basil.",
  ingredients: [
    { name: "Pizza Dough", quantity: "1 base" },
    { name: "Tomato Sauce", quantity: "1/2 cup" },
    { name: "Mozzarella", quantity: "150g" },
    { name: "Basil Leaves", quantity: "few" },
    { name: "Olive Oil", quantity: "1 tbsp" },
  ],
  steps: [
    "Roll out pizza dough.",
    "Spread tomato sauce evenly.",
    "Add mozzarella slices.",
    "Bake in oven at high temperature.",
    "Garnish with basil and drizzle olive oil."
  ],
},
{
  id: 10,
  name: "Risotto alla Milanese",
  cuisine: "Italian",
  time: "35 min",
  difficulty: "Medium",
  emoji: "🍚",
  image: risotaImg,
  description: "Creamy saffron-infused risotto from Milan.",
  ingredients: [
    { name: "Arborio Rice", quantity: "1 cup" },
    { name: "Saffron", quantity: "a pinch" },
    { name: "Butter", quantity: "2 tbsp" },
    { name: "Parmesan", quantity: "1/2 cup" },
    { name: "Onion", quantity: "1 pc" },
  ],
  steps: [
    "Sauté onion in butter.",
    "Add rice and toast lightly.",
    "Add warm broth gradually while stirring.",
    "Mix in saffron.",
    "Finish with parmesan and butter."
  ],
}, 
{ 
  id: 11,
  name: "Ratatouille",
  cuisine: "French",
  time: "40 min",
  difficulty: "Medium",
  emoji: "🍲",
  image: ratImg,
  description: "Traditional French vegetable stew with layered flavors.",
  ingredients: [
    { name: "Zucchini", quantity: "1 pc" },
    { name: "Eggplant", quantity: "1 pc" },
    { name: "Tomatoes", quantity: "2 pcs" },
    { name: "Bell Peppers", quantity: "1 pc" },
    { name: "Olive Oil", quantity: "2 tbsp" },
  ],
  steps: [
    "Slice all vegetables evenly.",
    "Layer them in a baking dish.",
    "Drizzle olive oil and season.",
    "Bake until tender.",
    "Serve warm."
  ],
},
{
  id: 12,
  name: "Croque Monsieur",
  cuisine: "French",
  time: "20 min",
  difficulty: "Easy",
  emoji: "🥪",
  image: croqueImg,
  description: "Classic French grilled ham and cheese sandwich with béchamel.",
  ingredients: [
    { name: "Bread Slices", quantity: "2 pcs" },
    { name: "Ham", quantity: "2 slices" },
    { name: "Cheese", quantity: "2 slices" },
    { name: "Butter", quantity: "1 tbsp" },
    { name: "Milk", quantity: "1/2 cup" },
  ],
  steps: [
    "Prepare a simple béchamel sauce.",
    "Layer ham and cheese between bread.",
    "Spread béchamel on top.",
    "Grill until golden and crispy.",
    "Serve hot."
  ],
},
];

export const communityPosts = [
  {
    id: 1,
    user: "Meera K.",
    avatar: "👩‍🍳",
    dish: "Mango Lassi Tart",
    description: "Made this for a Sunday brunch! The mango curd is silky smooth and not too sweet.",
    likes: 42,
    comments: [
      { user: "Arun", text: "That colour is stunning! How long did the curd take?" },
      { user: "Chef Ravi", text: "Beautiful plating — try adding cardamom next time!" },
    ],
    image: mangoImg,
    tag: "Dessert",
  },
  {
    id: 2,
    user: "Lena F.",
    avatar: "👩",
    dish: "Herb Butter Pasta",
    description: "Simple weeknight dinner. The herb butter makes all the difference!",
    likes: 28,
    comments: [
      { user: "Marco", text: "I make this every Friday! Love it." },
    ],
    image: butterImg,
    tag: "Pasta",
  },
  {
    id: 3,
    user: "Sam T.",
    avatar: "🧑‍🍳",
    dish: "Sourdough Pancakes",
    description: "Used my sourdough discard — tangiest, fluffiest pancakes of my life.",
    likes: 61,
    comments: [
      { user: "Priya", text: "Brilliant idea to use discard! Recipe please?" },
      { user: "Chef Noor", text: "The bubbles on those pancakes are perfect." },
    ],
    image: pancakeImg,
    tag: "Breakfast",
  },
];

export const stores = [
  { id: 1, name: "Green Basket Market", distance: "0.4 km", rating: 4.5, type: "Supermarket", emoji: "🛒" },
  { id: 2, name: "Farm Fresh Produce", distance: "0.9 km", rating: 4.8, type: "Fresh Produce", emoji: "🥦" },
  { id: 3, name: "Daily Needs Store", distance: "1.2 km", rating: 4.1, type: "Convenience", emoji: "🏪" },
  { id: 4, name: "Spice & Grain Co.", distance: "1.8 km", rating: 4.6, type: "Specialty", emoji: "🌶️" },
  { id: 5, name: "Metro Supermart", distance: "2.3 km", rating: 4.3, type: "Supermarket", emoji: "🏬" },
];
